<template>
  <v-card v-bind="$attrs">
    <v-card-title :class="{'changed': changed}">
      {{label}}
      <v-spacer></v-spacer>
      <v-btn fab x-small color="primary" v-if="allow_create" @click="createItem"><v-icon>mdi-plus</v-icon></v-btn>
    </v-card-title>
    <v-divider></v-divider>
    <slot name="body" :items="items" v-if="items.length > 0">
      <v-list nav max-height="calc(100vh - 270px)" outline style="overflow-y: auto">
        <draggable
          :animation="200"
          :group="'description'"
          :disabled="!allow_sort"
          ghostClass="moving"
          handle=".handle"
          v-model="items"
        >
          <slot 
            name="list-content" 
            :items="items" 
            :allow_create="allow_create" 
            :allow_edit="allow_edit" 
            :allow_delete="allow_delete" 
            :allow_sort="allow_sort" 
            :editItem="editItem"
            :deleteItem="deleteItem"
          >
          
            <v-list-item link v-for="(item, idx) in items" :key="idx" class="hover-master">
              <slot name="list-item" :item="item" :idx="idx">
                {{item}}
              </slot>
              <div class="hover-slave">
                <slot name="custom-interations" :item="item" :idx="idx"/>
                <v-btn icon color="primary" v-if="allow_edit" @click="editItem(idx)"><v-icon>mdi-pen</v-icon></v-btn>
                <v-btn icon color="error" v-if="allow_delete" @click="deleteItem(idx)"><v-icon>mdi-trash-can-outline</v-icon></v-btn>
                <v-btn class="handle" icon color="primary" style="cursor: grab" v-if="allow_sort"><v-icon>mdi-swap-vertical</v-icon></v-btn>
              </div>
            </v-list-item>
          </slot>
        </draggable>
      </v-list>
    </slot>
    <v-alert v-else elevation="0" type="warning" colored-border border="left">
      {{empty_list_label || $t('Нет данных')}}
    </v-alert>
    <v-dialog v-model="edit_modal" scrollable :max-width="edit_dialog_width || '50vw'" style="z-index: 3000">
      <slot name="dialog" :item="editing_item" :is_new="is_new" :submit="modalSubmit" :showing="edit_modal" :idx="active_item_id" :remove="() => deleteItem(active_item_id)" :close="closeModal" />
    </v-dialog>
    <v-dialog v-model="delete_modal" :max-width=" delete_dialog_width || '30vw'" style="z-index: 3000">
      <v-card>
        <v-card-title>
          <T>Подтверждение</T>
        </v-card-title>
        <v-card-text><T>Это действие приведет к удалению элемента. Продолжить?</T> </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text color="secondary" @click="delete_modal = false"><v-icon>mdi-close</v-icon><T>Отмена</T></v-btn>
          <v-btn text color="error" @click="approveDelete"><v-icon>mdi-delete</v-icon><T>Удалить</T></v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-card>
</template>

<script>
import draggable from 'vuedraggable'

export default {
  props: {
    label: String,
    hint: String,
    empty_list_label: String,
    allow_delete: Boolean,
    allow_edit: Boolean,
    allow_create: Boolean,
    allow_sort: Boolean,
    original_value: Array,
    value:  Array,
    key_field: [String, undefined],
    edit_dialog_width: String,
    delete_dialog_width: String,
    default_item: {
      type: Object,
      default: () => ({})
    }
  },
  data: () => ({
    edit_modal: false,
    delete_modal: false,
    is_new: false,
    active_item_id: undefined,
    editing_item: {}
  }),
  methods: {
    createItem() {
      this.active_item_id = undefined
      this.editing_item = JSON.parse(JSON.stringify(this.default_item))
      this.is_new = true
      this.edit_modal = true
    },
    editItem(idx) {
      this.active_item_id = idx
      this.editing_item = JSON.parse(JSON.stringify(this.items[idx]))
      this.is_new = false
      this.edit_modal = true
    },
    deleteItem(idx){
      this.active_item_id = idx
      this.delete_modal = true
    },
    approveDelete(){
      this.items = this.items.filter((el, idx) => idx != this.active_item_id)
      this.active_item_id = undefined
      this.delete_modal = false
      this.edit_modal = false
    },
    modalSubmit(){
      if (this.active_item_id !== undefined) {
        this.items = this.items.map((el, elidx) => elidx === this.active_item_id ? this.editing_item : el)
      } else {
        this.items = [...this.items, JSON.parse(JSON.stringify(this.editing_item))]
      }
      this.edit_modal = false
    },
    closeModal() {
      this.edit_modal = false
    }
  },
  computed: {
    items: {
      get(){
        return this.value || []
      },
      set(v){
        this.$emit('input', v)
      }
    },
    current_item: {
      get(){
        return this.active_item_id ? this.items[this.active_item_id] : JSON.parse(JSON.stringify(this.default_item))
      }
    },
    changed() {
      return this.original_value ? JSON.stringify(this.value) !== JSON.stringify(this.original_value) : false
    }
  },
  components:{
    draggable
  }
}
</script>

<style scoped>
.moving {
  opacity: 0;
  cursor: grabbing !important;
}

.hover-master {
  position: relative;
}

.hover-slave {
  position: absolute;
  right: 8px;
  opacity: 0;
  transition: all .1s ease-in-out;
}

.hover-master:hover .hover-slave {
  opacity: 1;
}

.changed::after {
  content: " ";
  color: white;
  text-align: center;
  vertical-align: center;
  padding: 0;
  width: 10px;
  height: 10px;
  position: absolute;
  left: -5px;
  top: -5px;
  border-radius: 50%;
  background: var(--v-warning-base);
}
</style>